import SelectModal from '@/components/Select/SelectModal';
import SentimentBadge from '@/features/Feedback/field/Sentiment/SentimentBadge';
import { type FeedbackSentiment, sentimentsOptions } from '@/types/feedbackConst';

export interface Props {
  feedbackKey: string;
  useShortcut?: boolean;
  selected?: number;
  name: string;
  triggerEl?: HTMLDivElement | null;
  onSelect: (key: string | number) => void;
}

const SentimentSelectModal = ({
  selected,
  name,
  useShortcut,
  triggerEl,
  onSelect,
}: Props) => {
  return (
    <SelectModal
      name={name}
      data={() => ({
        list: sentimentsOptions,
        cursor: null,
      })}
      searchOptions={{
        enable: true,
      }}
      mapper={(op) => {
        return <SentimentBadge type={Number(op.value) as FeedbackSentiment} />;
      }}
      value={selected ? String(selected) : null}
      onSelect={onSelect}
      shortcut={useShortcut ? 'KeyS' : ''}
      width="150px"
      triggerEl={triggerEl}
    />
  );
};

export default SentimentSelectModal;
